import { scrollPillMenuToCurrent, updatePillMenuOverflow } from './menupill'

var shouldDelayInitialMobilePillTransition = layData.navigation_transition_use_revealing_transition_on_first_visit == 'on'
var initialMobilePillTransitionReady = !shouldDelayInitialMobilePillTransition
var initialMobilePillTransitionFallback = null
var initialMobilePillTransitionRelease = null

function enableInitialMobilePillTransition() {
	if (initialMobilePillTransitionReady || initialMobilePillTransitionRelease) {
		return
	}
	if (initialMobilePillTransitionFallback) {
		clearTimeout(initialMobilePillTransitionFallback)
		initialMobilePillTransitionFallback = null
	}
	initialMobilePillTransitionRelease = setTimeout(function () {
		initialMobilePillTransitionReady = true
		initialMobilePillTransitionRelease = null
		window.requestAnimationFrame(function () {
			window.requestAnimationFrame(function () {
				jQuery('.mobile-menu-pill[data-lay-pill-positioned="true"]').addClass('mobile-menu-pill-transition')
			})
		})
	}, 750)
}

if (shouldDelayInitialMobilePillTransition) {
	window.laytheme.on('transition_navigation_in_completed', enableInitialMobilePillTransition)
	initialMobilePillTransitionFallback = setTimeout(enableInitialMobilePillTransition, 5000)
}

// Function to position the mobile pill
function positionMobilePill() {
	jQuery('.mobile-menu-style-pill_menu_style').each(function () {
		var $nav = jQuery(this).closest('.laynav.mobile-nav')
		if (this.getAttribute('data-lay-pill-overflow-ready') !== 'true') {
			updatePillMenuOverflow(this)
		}
		var navrect = this.getBoundingClientRect()
		var $pill = jQuery(this).find('.mobile-menu-pill')
		var hasPositionedPill = $pill.attr('data-lay-pill-positioned') === 'true'

		var $current = jQuery(this).find('.lay-anchor-menu-item.current-menu-item')
		if($current.length == 0) {
			$current = jQuery(this).find('.current-menu-item')
		}

		if($current.length == 0) {
			$pill.addClass('mobile-menu-opacity-pill-transition');
			$pill.removeClass('mobile-menu-pill-transition');
			$pill.removeAttr('data-lay-pill-positioned');
			$pill.css({
				opacity: 0,
			})
			return;
		}
		var currentrect = $current[0].getBoundingClientRect()

		var current_w = currentrect.width
		var current_top = currentrect.top
		var current_left = currentrect.left

		// Get padding values from CSS
		var navpadding = parseInt(jQuery(this).css('padding'))
		var pillpadding = parseInt(jQuery(this).find('.mobile-menu-pill').css('padding'))
		// opacity transition
		$pill.addClass('mobile-menu-opacity-pill-transition');
		if (hasPositionedPill && initialMobilePillTransitionReady) {
			$pill.addClass('mobile-menu-pill-transition');
			$pill[0].offsetWidth;
		} else {
			$pill.removeClass('mobile-menu-pill-transition');
		}

		var current_target_top = current_top - navrect.top - pillpadding - navpadding
		var current_target_left = current_left - navrect.left - pillpadding - navpadding + $nav[0].scrollLeft
		var pill_h = $nav[0].getBoundingClientRect().height - navpadding * 2

		$pill.css({
			transform: 'translate(' + current_target_left + 'px, ' + current_target_top + 'px)',
			width: current_w,
			opacity: 1,
			height: pill_h + 'px',
		})

		$pill.attr('data-lay-pill-positioned', 'true');
		scrollPillMenuToCurrent($nav[0], $current[0], navpadding, hasPositionedPill && initialMobilePillTransitionReady, pillpadding)
		if (!hasPositionedPill && initialMobilePillTransitionReady) {
			window.requestAnimationFrame(function () {
				if ($pill.attr('data-lay-pill-positioned') === 'true') {
					$pill.addClass('mobile-menu-pill-transition');
				}
			})
		}
	})
}

// Wait for webfonts to load before first positioning
if (document.fonts && document.fonts.ready) {
	document.fonts.ready.then(function() {
		// Do initial positioning after fonts are loaded
		positionMobilePill();
	});
} else {
	// Fallback for browsers that don't support document.fonts
	setTimeout(function() {
		positionMobilePill();
	}, 100);
}

window.laytheme.on('current-menu-point-activated', function () {
	positionMobilePill();
})

var breakpointBelow =  window.innerWidth < parseInt(layData.phone_menu_breakpoint, 10);
var lastBreakpointBelow = breakpointBelow;

jQuery(window).on('window_width_changed', function () {
	//breakpointBelow = window.innerWidth < parseInt(layData.phone_menu_breakpoint, 10);
	//if(breakpointBelow && lastBreakpointBelow == false) {
		jQuery('.mobile-menu-pill').removeClass('mobile-menu-pill-transition');
		jQuery('.mobile-menu-pill').removeAttr('data-lay-pill-positioned');
		jQuery('.mobile-menu-style-pill_menu_style').each(function () {
			this.removeAttribute('data-lay-pill-overflow-ready')
			updatePillMenuOverflow(this)
		})
		//jQuery('.mobile-menu-pill').css({
		//	opacity: 0,
		//})
		setTimeout(function() {
			positionMobilePill();
		}, 0);
	//}
	//lastBreakpointBelow = breakpointBelow;
})

jQuery(window).on('lay_pill_menu_position_changed', function () {
	jQuery('.mobile-menu-style-pill_menu_style').each(function () {
		this.removeAttribute('data-lay-pill-overflow-ready')
		updatePillMenuOverflow(this)
	})
	positionMobilePill()
})
